<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card class="py-5">
          <v-toolbar flat>
            <v-col cols="12" class="px-0 py-5">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Subscriber Activation
                    <div class="month-label">
                      {{
                        `${formatDate(this.dates[0])} - ${formatDate(
                          this.dates[1]
                        )}`
                      }}
                      Report
                    </div>
                  </v-toolbar-title>
                </div>
                <div class="ml-auto d-flex">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="dates"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" v-bind="attrs" v-on="on">
                        <v-icon class="mr-2">mdi-calendar</v-icon> Choose Dates
                      </v-btn>
                    </template>
                    <v-date-picker v-model="dates" range>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(dates)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>
              </div>
            </v-col>
            <!-- <v-spacer></v-spacer> -->
          </v-toolbar>

          <!-- <v-divider></v-divider> -->
        </v-card>
      </v-col>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Subscriber Activation
                  </v-toolbar-title>
                </div>
                <!-- <div class="ml-auto">
                  <v-btn color="primary" @click="goBack()">
                    <v-icon class="mr-2">mdi-arrow-left</v-icon> Back
                  </v-btn>
                </div> -->
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <!-- <template v-slot:expanded-item="{ headers, item }">
              <td class="p-0" :colspan="headers.length">
                <v-data-table
                  :headers="headers"
                  :items="item.areas"
                  :loading="table.loading"
                  :single-expand="table.singleExpand"
                  :expanded.sync="table.expanded"
                  show-expand
                  item-key="area"
                  hide-default-footer
                  loading-text="Loading... Please wait"
                  class="sub-areas"
                >
                  <template v-slot:[`item.data-table-expand`]></template>
                </v-data-table>
              </td>
            </template> -->

            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <template v-slot:[`item.isPaid`]="{ item }">
              {{ item.isPaid ? "Yes" : "No" }}
            </template>

            <template v-slot:[`item.amountPaid`]="{ item }">
              {{ item.amountPaid ? item.amountPaid.toLocaleString() : 0 }}
            </template>

            <template v-slot:[`item.todayRevenue`]="{ item }">
              {{ item.todayRevenue ? item.todayRevenue.toLocaleString() : 0 }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      menu: false,
      modal: false,
      dates: [
        moment().format("YYYY-MM-DD"),
        moment(this.date).add(1, 'days').format("YYYY-MM-DD"),
        // "2023-03-02",
      ],
      search: "",
      table: {
        expanded: [],
        singleExpand: false,
        sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Subscriber Name",
            value: "subscriberName",
          },
          { text: "Account Number", value: "accountNumber" },
          { text: "Mobile Number", value: "mobileNumber" },
          { text: "Retailer Name", value: "retailerName" },
          { text: "Dealer Name", value: "dealerName" },
          { text: "Package", value: "package" },
          { text: "Distributor Name", value: "distributorName" },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$drs
        .post(`/broker/pf-int/subscriber-activation`, {
          startDate: this.dates[0],
          endDate: this.dates[1],
        })
        .then((response) => {
          
          const newArr = response.data;
          console.log(newArr);
          newArr.data.map((obj) => {
            obj.subscriberName = obj.firstName + " " + obj.lastName;
          });

          this.table.data = newArr.data;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    viewDrawDetail(data) {
      this.$store.dispatch("addDrawDetails", data);
      this.$router
        .push({ path: `${this.$route.matched[0].path}/draw/view/${data.id}` })
        .catch(() => {});
    },

    row_classes() {
      return "row_classes";
    },

    formatDate(d) {
      return moment(d).format("MMM DD, YYYY");
    },
  },

  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    dates(e) {
      if (e.length > 1) {
        this.getList();
      }
    },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
